import styled from 'styled-components';

const LiveSessionContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  background-color: ${({theme}) => theme.colors.background};
`;

export default LiveSessionContainer;
